'use client';

import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { useAuth } from '@clerk/nextjs';
// import { useToast } from '@/components/ui/use-toast'; // Reverted: Project uses sonner
import { toast } from "sonner"; // Use sonner toast
import { LandingHeader } from '@/components/landing/header';
import { LandingHero } from '@/components/landing/hero';
import { WhoItsFor } from '@/components/landing/who-its-for';
import { WhyCareAdvisorWorks } from '@/components/landing/why-care-advisor-works';
import { SolveRealProblems } from '@/components/landing/solve-real-problems';
import { HowItHelpsYou } from '@/components/landing/how-it-helps-you';
import { HowCareAdvisorWorks } from '@/components/landing/how-care-advisor-works';
import { WhatUsersSay } from '@/components/landing/what-users-say';
import { KeyFeatures } from '@/components/landing/key-features';
import { ReadyToTry } from '@/components/landing/ready-to-try';
import { LandingFooter } from '@/components/landing/footer';

export default function Home() {
  const router = useRouter();
  const { isSignedIn, orgId, isLoaded } = useAuth();
  // const { toast } = useToast(); // Reverted

  useEffect(() => {
    if (isLoaded && isSignedIn) {
      const targetUrl = orgId ? `/organization/${orgId}` : '/chat';
      router.push(targetUrl);
    }
  }, [isLoaded, isSignedIn, orgId, router]);

  if (!isLoaded || isSignedIn) {
    return (
      <div className="flex h-screen items-center justify-center">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <main className="flex min-h-screen flex-col bg-background">
      <LandingHeader />
      <LandingHero />
      <WhoItsFor />
      <WhyCareAdvisorWorks />
      <SolveRealProblems />
      <HowItHelpsYou />
      <HowCareAdvisorWorks />
      <WhatUsersSay />
      <KeyFeatures />
      <ReadyToTry />
      <LandingFooter />
    </main>
  );
} 